import { Box, Skeleton, Text, useMantineTheme } from "@mantine/core";
import { ResponsiveLine } from "@nivo/line";
import { nivotheme } from "../nivoChartTheme";
import { Defs } from "@nivo/core";
import { area, curveMonotoneX, curveBasis } from "d3-shape";
import { mockTestAnalyticsLineChart } from "../common/mockdata";

const AnalyticsLineChart = ({ data }) => {
    // const data = mockTestAnalyticsLineChart();

    // console.log({ AnalyticsLineChartData: data });
    const theme = useMantineTheme();
    const AreaLayer = ({ series, xScale, yScale, innerHeight }) => {
        // console.log("series", { series, xScale, yScale, innerHeight });
        const areaGenerator = area()
            .x((d) => xScale(d.data.x))
            .y0((d) => {
                const {
                    data: { x: x_coord },
                } = d;
                let averageMarks = series
                    .filter((x) => x.id == "Average")[0]
                    .data.filter(({ data: { x } }) => x == x_coord)[0].data.y;

                return yScale(Math.max(0, averageMarks - 25));
            })

            .y1((d) => {
                const {
                    data: { x: x_coord },
                } = d;
                // get the average of topper and average student
                let topperMarks = series
                    .filter((x) => x.id == "Topper")[0]
                    .data.filter(({ data: { x } }) => x == x_coord)[0].data.y;

                let averageMarks = series
                    .filter((x) => x.id == "Average")[0]
                    .data.filter(({ data: { x } }) => x == x_coord)[0].data.y;

                // console.log({
                //     topperMarks,
                //     averageMarks,
                // });

                return yScale((topperMarks + averageMarks) / 2 - 3);
            })
            .curve(curveBasis);

        return (
            <>
                <Defs
                    defs={[
                        {
                            id: "pattern",
                            type: "patternLines",
                            background: "transparent",
                            color: "#3daff7",
                            lineWidth: 1,
                            spacing: 6,
                            rotation: -45,
                        },
                    ]}
                />
                <path
                    d={areaGenerator(series[0].data)}
                    fill="url(#pattern)"
                    fillOpacity={0.4}
                    stroke="#3daff76A"
                    strokeWidth={2}
                />
            </>
        );
    };

    if (!!!data) {
        // data is null
        return <Skeleton m={10} />;
    }

    return (
        <ResponsiveLine
            data={data}
            margin={{ top: 50, right: 10, bottom: 50, left: 60 }}
            xScale={{
                type: "point",
                format: "%Y-%m-%d",
                useUTC: false,
                precision: "day",
            }}
            yScale={{
                type: "linear",
                min: 0,
                max: 100,
                stacked: false,
                reverse: false,
            }}
            // xFormat="time:%b %d"
            colors={[
                theme.colors.orange[6],
                theme.colors.green[6],
                theme.colors.blue[6],
            ]}
            curve="natural"
            theme={nivotheme(theme)}
            // tooltip={({ point }) => {
            //     // console.log(point);
            //     let x_coord = point.data.x
            //     let y_coord = point.data.y
            //     return "point";
            // }}
            yFormat=" >-.2f"
            axisTop={null}
            axisRight={null}
            layers={[
                "grid",
                "markers",
                "areas",
                AreaLayer,
                "lines",
                "slices",
                "axes",
                "points",
                "legends",
                "mesh",
            ]}
            axisBottom={{
                // format: "%b %d",
                orient: "bottom",
                tickSize: 2,
                tickPadding: 5,
                tickRotation: 15,
                legend: "Test Taken",
                legendOffset: 45,
                legendPosition: "middle",
            }}
            axisLeft={{
                orient: "left",
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legend: "Average Marks",
                legendOffset: -50,
                legendPosition: "middle",
                format: (v) => `${v}%`,
            }}
            pointSize={10}
            pointColor={{ theme: "background" }}
            pointBorderWidth={2}
            pointBorderColor={{ from: "serieColor" }}
            pointLabelYOffset={-12}
            useMesh={true}
            legends={[
                {
                    anchor: "top",
                    direction: "row",
                    justify: false,
                    translateX: 0,
                    translateY: -25,
                    itemsSpacing: 0,
                    itemDirection: "left-to-right",
                    itemWidth: 80,
                    itemHeight: 20,
                    itemOpacity: 0.75,
                    symbolSize: 12,
                    symbolShape: "circle",
                    symbolBorderColor: "rgba(0, 0, 0, .5)",
                    effects: [
                        {
                            on: "hover",
                            style: {
                                itemBackground: "rgba(0, 0, 0, .03)",
                                itemOpacity: 1,
                            },
                        },
                    ],
                },
            ]}
        />
    );
};

export default AnalyticsLineChart;
